export default __webpack_public_path__ + "static/media/searchicon.ec205918.svg";